module.exports = __webpack_public_path__ + "static/img/batterytype.0e2ba6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/batterytype.png
// module id = ij2d
// module chunks = 3